import React from 'react';
import { Modal } from '@gerdau/hefesto';

import { ModalOverlay } from './styles';
import { useLocation } from 'react-router-dom';
import { SalesOrderItem } from '../../../../store/ducks/new-long-steel-orders/types';
import { useDispatch, useSelector } from 'react-redux';
import { loadUpdateOrderItems } from '../../../../store/ducks/new-long-steel-orders/actions';
import { updateQueryParam } from '../../../../utils/updateQueryParams';
import { ApplicationState } from '../../../../store';

export const OrderCancelConfirm = ({
  items,
  cancelMessage
}: {
  items: SalesOrderItem[];
  cancelMessage: string;
}) => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pending = params.get('cancel') === 'pending';

  const loading = useSelector(
    (state: ApplicationState) =>
      state.newLongSteelOrders.updateItems.loading.cancelOrders
  );

  if (!pending || !items || loading) {
    return null;
  }

  const dispatch = useDispatch();

  const handleClose = () => {
    updateQueryParam('cancel');
  };

  const handleConfirm = () => {
    dispatch(
      loadUpdateOrderItems({
        itemsSelected: items,
        cancelMessage: cancelMessage,
        typeAction: 'cancel'
      })
    );
  };

  return (
    <ModalOverlay width={564}>
      <Modal
        title={`Solicitar cancelamento de ${items.length} ite${
          items.length > 1 ? 'ns' : 'm'
        }`}
        modalSize="sm"
        buttons={{
          left: {
            name: 'button-close-cancel-items-close',
            children: 'Fechar',
            onClick: handleClose,
            type: 'button'
          },
          right: {
            name: 'button-close-cancel-items-confirm',
            children: 'Solicitar cancelamento',
            onClick: handleConfirm,
            type: 'button',
            variant: 'danger'
          }
        }}
      >
        <span>
          Sua solicitação de cancelamento será analisada e respondida em até 3
          dias úteis. Deseja solicitar o cancelamento?
        </span>
      </Modal>
    </ModalOverlay>
  );
};
